import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withLocalize } from 'react-localize-redux';
import debounce from 'lodash/debounce';
import Icon, { IconSizes, IconVariants } from '../components/foundations/Icon';
import css from './DashboardOption.css';
import { DASHBOARD_PRIVACY_TYPES } from './consts';
import { trackDashboardsMixpanelEvent } from './utils';

const DashboardOption = ({
    isFavorite,
    onToggleFavorite,
    onDelete,
    dashboardId,
    dashboardName,
    creatorEmail,
    isShared,
    translate,
}) => {
    const debouncedToggleFavorite = useMemo(() => debounce(id => onToggleFavorite(id), 300), [onToggleFavorite]);

    const handleStarClick = e => {
        e.stopPropagation();
        debouncedToggleFavorite(dashboardId);
        trackDashboardsMixpanelEvent('Dashboard Favorite Toggled', {
            dashboard_name: dashboardName,
            is_favorite: !isFavorite,
        });
    };

    const handleDeleteClick = e => {
        e.stopPropagation();
        onDelete();
        trackDashboardsMixpanelEvent('Deleted Dashboard', {
            dashboard_name: dashboardName,
        });
    };

    const privacyStatus = isShared ? DASHBOARD_PRIVACY_TYPES.PUBLIC : DASHBOARD_PRIVACY_TYPES.PRIVATE;

    return (
        <div className={css.dashboardOption}>
            <Icon
                name={isFavorite ? 'star-fill' : 'star'}
                size={IconSizes.SMALL}
                variant={isFavorite ? IconVariants.ACTIVE : IconVariants.LIGHT}
                className={classNames({ [css.notFavorite]: !isFavorite })}
                onClick={handleStarClick}
            />
            <div className={css.content}>
                <span className={css.label}>{dashboardName}</span>
                <span className={css.metadata}>
                    {creatorEmail} - {translate(privacyStatus)}
                </span>
            </div>
            {onDelete && (
                <Icon
                    name="delete-2-line"
                    size={IconSizes.SMALL}
                    variant={IconVariants.LIGHT}
                    className={css.deleteIcon}
                    onClick={handleDeleteClick}
                />
            )}
        </div>
    );
};

DashboardOption.propTypes = {
    isFavorite: PropTypes.bool,
    onToggleFavorite: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    dashboardId: PropTypes.string.isRequired,
    dashboardName: PropTypes.string.isRequired,
    creatorEmail: PropTypes.string.isRequired,
    isShared: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(DashboardOption);
